import { render, staticRenderFns } from "./todospagos.vue?vue&type=template&id=e731becc"
import script from "./todospagos.vue?vue&type=script&lang=js"
export * from "./todospagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports